<template lang="pug">
  .container.grid-xl
    page-title(title="Assinatura" icon="fas fa-dollar-sign" subtitle="Detalhes da assinatura")
    .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
    div(v-else-if="subscription && !error")
      .columns
        .column.col-4.col-md-6.col-sm-12
          card-person.height-100(:person="subscription.person")
        .column.col-4.col-md-6.col-sm-12
          card-info.height-100(title="Detalhes da assinatura" icon="fas fa-dollar-sign")
            .card-body(slot="card-body")
              .text-ellipsis Status: #[span(:class="status.class") {{ status.label }}]
              .text-ellipsis Início em: #[span.text-bold {{ subscription.startAt | toDate }}]
              .text-ellipsis Expira em: #[span.text-bold {{ subscription.expiresIn | toDate }}]
              .text-ellipsis(v-if="subscription.status === 'canceled'") 
                | Cancelada em: #[span.text-bold {{ subscription.expiresIn | toDate }}]
            .card-footer(slot="card-footer" v-if="subscription.status !== 'canceled'")
              button.btn.btn-error.btn-sm(type="butotn" @click="cancelSubscription")
                i.fas.fa-ban
                |  Cancelar assinatura
        .column.col-4.col-md-6.col-sm-12
          card-info.height-100(title="Pagamento" icon="fas fa-money-bill-alt")
            .card-body(slot="card-body")
              .text-ellipsis Gateway: #[span.text-bold(:class="gateway.class") {{ gateway.label }}]
              .text-ellipsis Forma de pagamento: #[span.text-bold(:class="paymentMethod.class") {{ paymentMethod.label }}]
              .text-ellipsis Em atraso: #[span.text-bold {{ status.overdue | boolean }}]
      .py-2.my-2
        .divider.text-center(data-content="Detalhes do plano")
      div
        span.h3
          | {{ subscription.plan.title }} - {{ subscription.plan.price | currency('R$ ') }}
        span  / {{ subscription.plan.intervalType | planIntervalType }}
      .pb-2 #[cite {{ subscription.plan.description }}]
      card-info.mt-2(title="Coleções do plano" icon="fas fa-boxes")
        .card-body(slot="card-body")
          table.table.table-responsive
            thead
              tr
                th Título
                th(width="50") Status
                th.text-right(width="100") Ações
            tbody
              tr(v-for="collection in subscription.plan.collections")
                td.text-ellipsis {{ collection.title }}
                td
                  span(:class="collectionStatus(collection).class") {{ collectionStatus(collection).label }}
                td.text-right
                  router-link.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                    :to="{ name: 'collections.edit', params: { id: collection.id } }"
                    data-tooltip="Editar"
                  )
                    i.fas.fa-edit
    .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
</template>

<script>
import subscriptions from '@/services/subscriptions'
import {
  mapSubscriptionStatus,
  mapGateway,
  mapPaymentMethod,
  mapCollectionStatus,
} from '@/lib/constants'

export default {
  data() {
    return { loading: false, error: null, subscription: null }
  },
  computed: {
    status() {
      return mapSubscriptionStatus[this.subscription.status]
    },
    gateway() {
      return mapGateway[this.subscription.paymentGateway]
    },
    paymentMethod() {
      return mapPaymentMethod[this.subscription.paymentMethod]
    },
  },
  methods: {
    collectionStatus(collection) {
      return mapCollectionStatus[collection.status]
    },
    async fetchSubscription() {
      try {
        this.loading = true
        const { id } = this.$route.params
        const { data } = await subscriptions.show(id)
        this.subscription = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
    async cancelSubscription() {
      const options = {
        size: 'sm',
        title: 'Cancelar assinatura',
        cancelLabel: 'Não',
        okLabel: 'Sim, quero cancelar',
      }
      const { ok } = await this.$dialogs.confirm(
        'Tem certeza que deseja cancelar esta assinatura?',
        options,
      )
      if (ok) {
        try {
          await subscriptions.cancel(this.subscription.id)
          this.fetchSubscription()
          this.$toaster.success('Assinatura cancelada')
        } finally {
          this.loading = false
        }
      }
    },
  },
  async created() {
    this.fetchSubscription()
  },
}
</script>
